import React from 'react';
import { Stack, Typography } from '@mui/material';
// COMPONENTS
import DetailViewCard from '../../../../components/Card/DetailViewCard';
// HELPERS
import { getSubjectColor } from '../../../../helper';
// CONSTANTS
import { TP_COLORS } from '../../../../constants';

export interface IImageContainer {
  subjectCode: string;
  subject: string;
  curriculum: string;
  grade: string;
}

const ImageContainer: React.FC<IImageContainer> = ({
  subjectCode,
  subject,
  curriculum,
  grade,
}) => {
  return (
    <div
      style={{
        marginBottom: '30px',
        padding: '0 5%',
        background: `url('${
          process.env.PUBLIC_URL
        }/images/shapes/learning-gadgets.transparent.png') top right/contain no-repeat, ${getSubjectColor(
          subject
        )}`,
      }}
    >
      <div
        style={{
          padding: '30px',
          background: `url('${process.env.PUBLIC_URL}/images/shapes/square-pieces-transparent.png') 20%/contain no-repeat`,
        }}
      >
        <Stack direction="row" justifyContent="flex-end">
          <DetailViewCard
            title={subjectCode}
            titleProps={{ variant: 'subtitle1', fontWeight: 600 }}
            containerProps={{
              sx: {
                padding: '0px 8px',
                backgroundColor: TP_COLORS.white,
                color: TP_COLORS.black,
              },
            }}
          />
        </Stack>
        <Typography variant="h4" sx={{ color: TP_COLORS.white }}>
          {subject}
        </Typography>
        <Typography
          variant="h6"
          fontWeight={600}
          sx={{ color: TP_COLORS.white, opacity: 0.5 }}
        >
          {curriculum}
        </Typography>
        <Typography
          variant="h6"
          fontWeight={600}
          sx={{ color: TP_COLORS.white, opacity: 0.5 }}
        >
          {grade}
        </Typography>
      </div>
    </div>
  );
};

export default ImageContainer;
